import React, { useContext, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { ConfigContext } from "../context/GlobalContext";
import { toast } from "react-toastify";
import { DeleteCustomerLedger, DeleteInvoice } from "../data";
import { Languages } from "../Utils/Languages";
import * as actionType from "../context/actions";


const DeleteCustomerLedgerView = ({ customerId, ledgerId }) => {

    const { state, dispatch } = useContext(ConfigContext);
    const [showModal, setShowModal] = useState(false);

    const handleDelete = async () => {
        const customer = state?.CUSTOMERS?.find(c => c.customerId === customerId);
        const selectedBusiness = state?.BUSINESSES?.find(b => b.companyId === customer?.companyId);
        const targetUid = selectedBusiness?.isShared ? selectedBusiness.ownerUid : state?.USERID;

        const { success, message } = await DeleteCustomerLedger(
            state,
            dispatch,
            customerId,
            ledgerId,
            targetUid
        );

        if (success) {
            toast.success(Languages[state?.LANGUAGE]?.invoice_delete_success_message);
        } else {
            toast.error(Languages[state?.LANGUAGE]?.inoive_delete_failed_message);
        }
        setShowModal(false);
    };

    return (
        <>
            {/* Delete Button */}
            <Link
                onClick={(e) => {
                    if (!state?.USERID) {
                        e.preventDefault();
                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                        return;
                    }
                    setShowModal(true);
                }}
                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
            >
                <Icon icon="mingcute:delete-2-line" />
            </Link>

            {/* Delete Confirmation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{Languages[state?.LANGUAGE]?.inoive_delete_conformation}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{Languages[state?.LANGUAGE]?.inoive_delete_conformation_text}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {Languages[state?.LANGUAGE]?.cancel}
                    </Button>
                    <Button variant="danger" className="bg-danger" onClick={handleDelete}>
                        {Languages[state?.LANGUAGE]?.delete}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteCustomerLedgerView